// extracted by mini-css-extract-plugin
export default {"container":"OptionInformation_container__BksB8"};